import * as yup from 'yup';
import { StringSchema } from 'yup';
import { UserValidation } from '../../../../types';

export interface StringValidation extends UserValidation {}

// build validation for string
export const buildStringValidators = ({ required, email, min, max, matches }: StringValidation) => {
  let schema: StringSchema<string | undefined | null, object> = yup.string();
  if (required) schema = schema.required(...required).nullable();
  if (email) schema = schema.email(...email).nullable();
  if (min) schema = schema.min(Number(min[0]), min[1]).nullable();
  if (max) schema = schema.max(Number(max[0]), max[1]).nullable();
  if (matches) {
    const [regex, message] = matches;
    schema = schema.matches(new RegExp(regex), message).nullable();
  }
  return schema;
};
